import { isAdminUser, isContributorUser } from '../../helpers';
import { isGroupOwnerOrModerator } from '../groups/helpers';
import { PublicUserProfile, UserProfile } from '../../api';

export const isModeratorAndAbove = (user: UserProfile | PublicUserProfile) => {
  const isModerator = isGroupOwnerOrModerator(user, '');
  return isModerator || isAdminUser(user);
};

export const isContributorAndAbove = (user: UserProfile | PublicUserProfile) => {
  const isModerator = isGroupOwnerOrModerator(user, '');
  return isContributorUser(user) || isModerator || isAdminUser(user);
};
